import React, { Fragment } from 'react'; // eslint-disable-line

const ColorRadio = (props) => {
    return (
        <div className={`color-radio radio ${props.rectangle ? ' rectangle' : ''} ${props.defaultChecked ? ' checked' : ''}`} style={{ '--colorVar': props.displayColor }}>
            <input data-qa={props.id} id={props.id} type="radio" name={props.name} onClick={props.handleClick} defaultChecked={props.defaultChecked} className="hidden" value={props.value} />
            <label />
        </div>
    );
};

export default ColorRadio;
